import React from "react";
import { useState, useRef, useMemo } from "react";
import {
    Box, Typography, Chip, Button, IconButton, Grid, TextField, Stack, Popper, Grow, Paper, ClickAwayListener
} from "@mui/material";
import moment from "moment";
import CustomPagination from "components/CustomPagination";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import Select from "react-select";
import TableComponent from "components/grid";
import calenderSVG from "assets/logo/Calendar";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuTrash2 } from "react-icons/lu";
import EditUser from "./EditUser";
import DeleteUser from "./DeleteUser";
import { useParams } from "react-router-dom";
import MapUser from "./MapUser";



const AllUsers = (props) => {
    const { data, loading, isFetching, handlePageChange, handlePageSizeChange,
        handleApplyFilters, handleClose, handleDelete, createSortHandler
        , handleReset, filters, setFilters, handleSelectChange, setOpen, mappedUser, open,
        order, orderBy, pageSize, currentPage, totalCount, setCurrentPage, setSearchTerm, searchTerm, trigger } = props;
    const { projectId } = useParams();
    // const [loading, setLoading] = useState(false);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [pageSize, setPageSize] = useState(10);
    // // const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [selected, setSelected] = useState([]);
    const [allSelected, setAllSelected] = useState(false);

    const [isEditUser, setIsEditUser] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [isDeleteUser, setIsDeleteUser] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isMapUser, setIsMapUser] = useState(false);

    const handleDeleteUser = (row) => {
        setSelectedUserId(row.id);
        setIsDeleteUser(true);
    }

    const handleCloseDeleteUser = () => {
        setIsDeleteUser(false);
        setSelectedUserId(null);
    };

    const handleEditUser = (row) => {
        setSelectedData(row.id);
        setIsEditUser(true);
    };

    const handleCloseEditUser = () => {
        setIsEditUser(false);
        setSelectedData(null);
    };

    // const [filters, setFilters] = useState({
    //     Designation: '',
    //     Email: '',
    //     Name: ''
    // });

    // const [tempFilters, setTempFilters] = useState({
    //     Designation: '',
    //     Email: '',
    //     Name: ''
    // });

    const hasFilters = filters.designations || filters.Email || filters.CreatedDate;


    const extractedDesignation = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item => item.designation).filter(Boolean))].sort((a, b) =>
            a.localeCompare(b)
        )
        : [];

    const userDesignation = extractedDesignation.map(designation => ({
        value: designation,
        label: designation
    }));

    const extractedEmail = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item => item.email).filter(Boolean))].sort((a, b) =>
            a.localeCompare(b)
        )
        : [];

    const userEmail = extractedEmail.map(email => ({
        value: email,
        label: email
    }));

    const extractedName = Array.isArray(data) && data.length > 0
        ? [...new Set(data.map(item =>
            item.firstName && item.lastName
                ? `${item.firstName} ${item.lastName}`
                : ""
        ).filter(Boolean))].sort((a, b) =>
            a.localeCompare(b)
        )
        : [];

    const userName = extractedName.map(fullname => ({
        value: fullname,
        label: fullname
    }));

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    // const handleDelete = (filterType) => {
    //     setFilters(prev => ({
    //         ...prev,
    //         [filterType]: ''
    //     }));
    // };

    // const handleReset = () => {
    //     setTempFilters({
    //         Designation: '',
    //         Email: '',
    //         Name: ''
    //     });

    //     setFilters({
    //         Designation: '',
    //         Email: '',
    //         Name: ''
    //     });
    // };

    // const handleApplyFilters = () => {
    //     setFilters(tempFilters);
    //     setCurrentPage(1);
    //     handleClose();
    // };

    // const handlePageChange = (newPage) => {
    //     setCurrentPage(newPage);
    // };

    // const handlePageSizeChange = (newSize) => {
    //     setPageSize(newSize);
    //     setCurrentPage(1);
    // };

    // const createSortHandler = (property) => {
    //     const isAsc = orderBy === property && order === 'asc';
    //     setOrder(isAsc ? 'desc' : 'asc');
    //     setOrderBy(property);
    // };

    // const processedData = useMemo(() => {
    //     // console.log("Processing data with filters:", filters);
    //     let result = [...data];

    //     if (filters.Designation) {
    //         result = result.filter(item => item.designation === filters.Designation);
    //     }

    //     if (filters.Email) {
    //         result = result.filter(item => item.email === filters.Email);
    //     }

    //     if (filters.Name) {
    //         result = result.filter(item => {
    //             const fullName = `${item.firstName} ${item.lastName}`.trim();
    //             return fullName.toLowerCase() === filters.Name.toLowerCase();
    //         });
    //     }

    //     if (searchText.trim() !== "") {
    //         const s = searchText.toLowerCase();
    //         result = result.filter((item) =>
    //             item.firstName?.toLowerCase().includes(s) ||
    //             item.lastName?.toLowerCase().includes(s) ||
    //             item.email?.toLowerCase().includes(s) ||
    //             item.phoneNumber?.includes(s)
    //         );
    //     }

    //     if (orderBy) {
    //         result = [...result].sort((a, b) => {
    //             const aValue = a[orderBy];
    //             const bValue = b[orderBy];

    //             if (orderBy === 'createddate') {

    //                 const aDate = new Date(aValue);
    //                 const bDate = new Date(bValue);
    //                 return order === 'asc' ? aDate - bDate : bDate - aDate;
    //             }

    //             if (typeof aValue === 'string') {
    //                 return order === 'asc'
    //                     ? aValue.localeCompare(bValue)
    //                     : bValue.localeCompare(aValue);
    //             }

    //             return order === 'asc' ? aValue - bValue : bValue - aValue;
    //         });
    //     }
    //     return result;
    // }, [data, filters, searchText, order, orderBy]);

    // const paginatedData = useMemo(() => {
    //     const startIndex = (currentPage - 1) * pageSize;
    //     const endIndex = startIndex + pageSize;
    //     return processedData.slice(startIndex, endIndex);
    // }, [processedData, currentPage, pageSize]);

    // const totalCount = processedData.length;

    const handleAssetMap = (row) => {
        setSelectedData(row.id);
        setIsMapUser(true);
    };

    const handleMapUserClose = () => {
        setIsMapUser(false);
        setSelectedData(null);
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let createdDate = "";
        if (value) {

            const localDate = new Date(value);
            createdDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: createdDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };

    const columns = [
        {
            name: "Name",
            field: "fullname",
            width: "300px",
            renderer: (row) => {
                // const isEditDisabled = projectId && row?.roleName?.[0] === "admin";
                const isEditDisabled = false;
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontFamily: "Outfit, sans-serif", fontSize: "13px", fontWeight: 600, color: "#172033" }}>
                            {row.firstName} {row.lastName}
                        </Typography>
                        <Box className="hoverButtons" sx={{ display: "none", ml: 2, gap: "10px" }}>
                            <Button
                                disabled={isEditDisabled}
                                startIcon={<EditIcon style={{ width: 11, height: 11, fill: "#433F5E" }} />}
                                onClick={() => handleEditUser(row)}
                                sx={{
                                    backgroundColor: "#E7E7EB",
                                    p: "2px 6px",
                                    borderRadius: "5px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    cursor: isEditDisabled ? "not-allowed" : "pointer",
                                    "&.Mui-disabled": {
                                        color: "#9CA3AF",
                                        backgroundColor: "#F1F1F1",
                                    },
                                }}
                            >
                                Edit
                            </Button>
                            <Button
                                startIcon={<LuTrash2 style={{ width: 11, height: 11 }} />}
                                onClick={() => handleDeleteUser(row)}
                                sx={{
                                    backgroundColor: "#E7E7EB",
                                    p: "2px 8px",
                                    borderRadius: "5px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    textTransform: 'none'
                                }}
                            >
                                Delete
                            </Button>
                            {mappedUser &&
                                <Button
                                    //startIcon={<LuTrash2 style={{ width: 11, height: 11 }} />}
                                    onClick={() => handleAssetMap(row)}
                                    sx={{
                                        backgroundColor: "#E7E7EB",
                                        p: "2px 8px",
                                        borderRadius: "5px",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        textTransform: 'none'
                                    }}
                                >
                                    Asset Mapping
                                </Button>
                            }
                        </Box>
                    </Box>
                );
            }
        },
        {
            name: "Designation",
            field: "designation",
            renderer: (row) => (
                <Chip
                    sx={{
                        height: "23px",
                        borderRadius: "5px",
                        backgroundColor: "#E7E7EB",
                        padding: "4px 8px",
                    }}
                    label={
                        <Box sx={{
                            fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: "12px",
                            color: "#5B5772",
                            letterSpacing: "0px"
                        }}>
                            {row.designation}
                        </Box>
                    }
                />
            ),
        },
        {
            name: "Mobile Number",
            field: "phoneNumber",
            renderer: (row) => (
                <>+91{row.phoneNumber}</>
            )
        },
        {
            name: "Email Id",
            field: "email",
        },
        // {
        //     name: "Assigned Role",
        //     field: "roleName",
        //     renderer: (row) => (
        //         <Box sx={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        //             {row?.roleName?.map((role, index) => (
        //                 <Chip
        //                     key={index} // Added key for React list rendering
        //                     sx={{
        //                         height: "23px",
        //                         borderRadius: "5px",
        //                         backgroundColor: "#E7E7EB",
        //                         padding: "4px 8px",
        //                     }}
        //                     label={
        //                         <Box sx={{
        //                             fontFamily: "Outfit",
        //                             fontWeight: 600,
        //                             fontSize: "12px",
        //                             color: "#5B5772",
        //                             letterSpacing: "0px"
        //                         }}>
        //                             {role}
        //                         </Box>
        //                     }
        //                 />
        //             ))}
        //         </Box>
        //     ),
        // },
        {
            name: "Created Date",
            field: "createdDate",
            renderer: (row) => (
                <>{moment(row.createdDate).format("Do MMM YYYY")}</>
            )
        },
        {
            name: "Last Login",
            field: "lastLogin",
            renderer: (row) => {
                return row.lastLogin
                    ? moment(row.lastLogin).format("Do MMM YYYY : h:mm A")
                    : "";
            }
        },
    ];

    if (loading || isFetching) return null;

    return (
        <>
            <Grid size={12}>
                <Grid container>
                    <Grid size={{ md: 8, sm: 6 }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                                padding: "8px 0",
                                alignItems: "center",
                                minHeight: "40px",
                                ml: 1,
                            }}
                        >
                            {filters.designations && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Designation:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {userDesignation.find(cat => cat.value === filters.designations)?.label || filters.designations}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('designations')}
                                />
                            )}

                            {filters.Email && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Email:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.Email}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('Email')}
                                />
                            )}

                            {filters.CreatedDate && (
                                <Chip
                                    label={
                                        <Typography variant="body2">
                                            <strong style={{ color: '#0E73F6' }}>Created Date:</strong>{" "}
                                            <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                {filters.CreatedDate ? moment(filters.CreatedDate).format('DD-MM-YYYY') : filters.CreatedDate}
                                            </span>
                                        </Typography>
                                    }
                                    sx={{
                                        backgroundColor: "rgba(25, 118, 210, 0.08)",
                                        border: 0
                                    }}
                                    variant="outlined"
                                    onDelete={() => handleDelete('CreatedDate')}
                                />
                            )}
                        </Stack>
                    </Grid>
                    <Grid size={{ md: 4, sm: 6 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: 'end',
                                p: "8px 0px"
                            }}
                        >
                            {!hasFilters && (
                                <TextField
                                    placeholder="Search Users"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    size="small"
                                    InputProps={{ startAdornment: <LuSearch size={16} style={{ marginRight: 8, color: "#64748B" }} /> }}
                                    sx={{
                                        width: { xs: "100%", sm: "360px", md: "420px" },
                                        backgroundColor: "#FFFFFF",
                                        "& .MuiOutlinedInput-root": { minHeight: "36px", borderRadius: "3px", fontFamily: "Outfit, sans-serif", fontSize: "13px", "& fieldset": { borderColor: "#CBD5E1" }, "&:hover fieldset": { borderColor: "#94A3B8" }, "&.Mui-focused fieldset": { borderColor: "#2563EB", borderWidth: "1px" } },
                                    }}
                                />
                            )}
                            <IconButton
                                ref={anchorRef}
                                onClick={handleToggle}
                            >
                                <MdOutlineFilterAlt size={24} color="#48535B" />
                            </IconButton>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                placement="bottom-end"
                                transition
                                disablePortal={false}
                                sx={{ zIndex: 2000 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {({ TransitionProps }) => (
                                    <Grow {...TransitionProps}>
                                        <Paper
                                            sx={{
                                                mt: 1,
                                                p: 2,
                                                borderRadius: 1,
                                                boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                width: 300,
                                            }}
                                        >
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <Box>
                                                    <Grid container spacing={2}>
                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Designation</Typography>
                                                            <Select
                                                                name="designations"
                                                                options={userDesignation}
                                                                placeholder="Select Designation"
                                                                value={
                                                                    userDesignation.find(option => option.value === filters.designations) || null
                                                                }
                                                                isClearable
                                                                onChange={(option) => handleSelectChange(option, "designations")}
                                                            />
                                                        </Grid>

                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Email</Typography>

                                                            <Select
                                                                name="Email"
                                                                options={userEmail}
                                                                placeholder="Select Email"
                                                                value={userEmail.find(option => option.value === filters.Email) || null}

                                                                isClearable
                                                                onChange={(option) => handleSelectChange(option, "Email")}

                                                            />
                                                        </Grid>

                                                        {/* <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Name</Typography>

                                                            <Select
                                                                name="Name"
                                                                options={userName}
                                                                placeholder="Select Name"
                                                                value={userName.find(option => option.value === filters.Name) || null}
                                                                isClearable
                                                                onChange={(option) => handleSelectChange(option, "Name")}

                                                            />
                                                        </Grid> */}
                                                        <Grid size={12}>
                                                            <Typography sx={{
                                                                fontFamily: 'Outfit',
                                                                fontWeight: 500,
                                                                fontSize: '16px',
                                                                lineHeight: '100%',
                                                                letterSpacing: "0px",
                                                                mb: 1
                                                            }}>Select Created Date</Typography>
                                                            <TextField
                                                                type="date"
                                                                name="CreatedDate"
                                                                value={filters.CreatedDate ? new Date(filters.CreatedDate).toISOString().split('T')[0] : ""}
                                                                onChange={handleDateChange}
                                                                onClick={(e) => {
                                                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                    if (input) input.showPicker?.();
                                                                }}
                                                                fullWidth
                                                                sx={{
                                                                    "& input::-webkit-calendar-picker-indicator": {
                                                                        display: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& input[type='date']": {
                                                                        appearance: "none",
                                                                        WebkitAppearance: "none",
                                                                    },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": {
                                                                            border: "none",
                                                                        },
                                                                    },
                                                                }}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                        >
                                                                            {calenderSVG}
                                                                        </Box>
                                                                    ),
                                                                    sx: {
                                                                        backgroundColor: "#E7E7EB",
                                                                        height: "40px",
                                                                        width: { xs: "100%", md: "100%" },
                                                                        borderRadius: "5px",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid size={12}>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Button onClick={handleReset}
                                                                    sx={{
                                                                        textTransform: "none",
                                                                        color: "#F15744",
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        borderRadius: "25px",
                                                                        fontWeight: 500,
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}>
                                                                    Reset
                                                                </Button>
                                                                <Button
                                                                    type="button"
                                                                    onClick={handleApplyFilters}
                                                                    variant="contained"
                                                                    sx={{
                                                                        backgroundColor: "#00344C",
                                                                        borderRadius: "25px",
                                                                        textTransform: "none",
                                                                        fontWeight: 500,
                                                                        fontSize: "14px",
                                                                        lineHeight: "100%",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                        color: "#FFFFFF",
                                                                        px: "20px",
                                                                        py: "15px",
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>

                            <IconButton onClick={() => trigger(filters)}>
                                <LuRefreshCw size={20} color="#48535B" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
                {isEditUser &&
                    <EditUser open={isEditUser} handleClose={handleCloseEditUser} rowDataId={selectedData} />
                }
                {isDeleteUser &&
                    <DeleteUser open={isDeleteUser} handleClose={handleCloseDeleteUser} userId={selectedUserId} />
                }
                {isMapUser &&
                    <MapUser open={isMapUser} handleClose={handleMapUserClose} rowDataId={selectedData} />
                }
            </Grid>

            <TableComponent
                data={data}
                isLoading={loading || isFetching}
                columns={columns}
                order={order}
                orderBy={orderBy}
                createSortHandler={createSortHandler}
            />
            <CustomPagination
                totalCount={totalCount}
                pageSize={pageSize}
                page={currentPage}
                onPageChange={handlePageChange}
                setCurrentPage={setCurrentPage}
                onPageSizeChange={handlePageSizeChange}
            />
        </>
    );
}

export default AllUsers;
